import { Switch } from 'react-router-dom'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import { useEffect } from 'react'
import KhsDetails from 'src/components/Khs/KhsDetails'

const KhsLayout = () => {
  useEffect(() => {})

  return (
    <>
      <Switch>
        <RouteMiddleware
          title={'Khs Data'}
          path='/individual/dashboard/khs'
          exact
          component={KhsDetails}
        />
      </Switch>
    </>
  )
}

export default KhsLayout
